<template>
  <!-- Distintivo de fuente de un campo (Administrador, Mediciones, PRM, Calc. o Sin fuente). -->
  <span class="src-chip" :class="source" v-tip="tipText">{{ $t('prm_summary_src_' + source) }}</span>
</template>

<script>
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmSummarySourceChip',

    directives: { tip },

    props: {
      source: { type: String, required: true }, // admin | medic | planif | prm | fact | contract | incid | resumen | calc | none
      tipOverride: { type: String, default: '' }, // tooltip a medida (si no, el genérico de la fuente)
    },

    computed: {
      // Los campos SIN FUENTE no llevan tooltip.
      tipText () {
        if (this.source === 'none') return ''
        return this.tipOverride || this.$t('prm_summary_src_' + this.source + '_tip')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .src-chip {
    display: inline-block; margin-left: 6px; font-size: 9px; font-weight: 700;
    text-transform: uppercase; letter-spacing: .03em; padding: 1px 5px; border-radius: 3px;
    white-space: nowrap; vertical-align: middle;
  }
  .src-chip:not(.none) { cursor: help; }
  // Fuentes reales: distintivo azul.
  .src-chip.admin, .src-chip.medic, .src-chip.planif, .src-chip.prm, .src-chip.fact, .src-chip.contract, .src-chip.incid, .src-chip.resumen, .src-chip.calc {
    background: #e7effb; color: #2b5cad; border: 1px solid #c3d5f2;
  }
  // Sin fuente: ámbar punteado (campo manual).
  .src-chip.none { background: #fff4d6; color: #8a6d00; border: 1px dashed #e0b52a; }
</style>
